import React, { useState, useEffect, useContext } from "react";
import { Breadcrumb, Container, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import Common_Button from "../../Common-Component/Common_Button/Common_Button";
import { Context } from "../../../utils/context";
import { orderGet } from "../../../utils/apis/myAccount/myAccount";
import Return_Reason_Modal from "../../Common_modal/Return_Reason_Modal/Return_Reason_Modal";

function Main_My_Account(props) {
  const [showReturn, setShowReturn] = useState(false);
  const [orderId, setOrderId] = useState("");

  const handleCancelClick = (orderId) => {
    console.log("orderId");

    setOrderId(orderId);
    setShowReturn(true);
  };

  var stepPercentage = 0;

  if (props.currentStep === 1) {
    stepPercentage = 0;
  } else if (props.currentStep === 2) {
    stepPercentage = 50;
  } else if (props.currentStep === 3) {
    stepPercentage = 100;
  } else {
    stepPercentage = 0;
  }
  const steps = [
    {
      links: "/order-history",
      icon: process.env.PUBLIC_URL + "/assets/Image/My_Profile/history.png",
      goto: "Order History",
    },
    {
      links: "/my-account",
      icon: process.env.PUBLIC_URL + "/assets/Image/My_Profile/account.png",
      goto: "My order Details ",
    },
    {
      links: "/address",
      icon: process.env.PUBLIC_URL + "/assets/Image/My_Profile/account.png",
      goto: "Add Address",
    },
    {
      links: "/ChangePassword",
      icon: process.env.PUBLIC_URL + "/assets/Image/My_Profile/password.png",
      goto: " Change Password",
    },
  ];

  const { IMG_URL } = useContext(Context);

  const [orders, setOrder] = useState([]);
  const getOrders = async () => {
    const res = await orderGet();
    if (res?.success) {
      setOrder(res?.data);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(2);
    return `${day}/${month}/${year}`;
  }

  useEffect(() => {
    getOrders();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const staticOrders = [
    {
      id: 1,
      createdAt: "2025-12-20T10:00:00Z",
      invoice_no: "INV123456",
      payment_status: 1,
      order: {
        payment_mode: "cod",
      },
      mrp: "499",
      quantity: "2",
      product: {
        name: "Cool Sneakers",
        delivery_charges: "50",
        image1: "sneakers1.jpg",
      },
      order_status: {
        id: 3, // Processing / Shipped status
      },
      return_order: {
        accept_reject: null,
      },
    },
    {
      id: 2,
      createdAt: "2025-12-18T15:30:00Z",
      invoice_no: "INV654321",
      payment_status: 0,
      order: {
        payment_mode: "online",
      },
      mrp: "1200",
      quantity: "1",
      product: {
        name: "Smart Watch",
        delivery_charges: "99",
        image1: "watch1.jpg",
      },
      order_status: {
        id: 4, // Delivered
      },
      return_order: {
        accept_reject: null,
      },
    },
  ];

  return (
    <>
      <section className="my-account my-account-main">
        <div className="container-fluid">
          <div className="heading_holder">
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={"/"}>Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={"/information"}>Information</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>
                <Link to={""}>My Order Details</Link>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <div className="back-text-holder">
            <Link to={"/information"}>
              <p>Back</p>
            </Link>
          </div>
          <div>
            <div className="">
              <h2 className="title">My Order Details</h2>
            </div>

            {orders?.data?.map((value, index) => (
              <div className="product-section-div" key={value?.id || index}>
                {value?.order_items?.map((item, ind) => (
                  <div key={item?.id || `${index}-${ind}`}>
                    {ind !== 0 && <hr className="my-4" />}
                    <div className="row">
                      <div className="col-xxl-10 col-lg-9 col-md-8 col-sm-7">
                        <div>
                          <p className="date">
                            Order Date : {formatDate(item?.createdAt)}
                          </p>

                          <h6 className="price">
                            <div>{item?.product?.name}</div>
                          </h6>

                          <h6 className="price">
                            ₹{" "}
                            {parseFloat(item?.mrp) * parseInt(item?.quantity) +
                              parseInt(item?.product?.delivery_charges || 0)}
                          </h6>
                        </div>
                      </div>

                      <div className="col-xxl-2 col-lg-3 col-md-4 col-sm-5">
                        <div>
                          <p className="date">
                            Order ID : {item?.order?.invoice_number}
                          </p>
                          <p className="date">
                            Payment Type :{" "}
                            {value?.order?.payment_mode === "cod"
                              ? "COD"
                              : "Online"}
                          </p>
                          <p className="date">
                            Payment Status :{" "}
                            {item?.payment_status == 1 ? "Paid" : "UnPaid"}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="product-div">
                      <div className="row">
                        <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-2 col-sm-3 col-4">
                          <div className="product">
                            <img
                              className="img-set"
                              src={`${IMG_URL}${item?.product?.image1}`}
                              alt={item?.product?.name}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Order Status */}
                    {item?.order_status?.id === 4 ||
                    item?.order_status?.id === 5 ||
                    item?.order_status?.id === 6 ? (
                      <div className="stepper-div">
                        <h5 className="text-danger mt-4">
                          {value?.order_status?.id === 4 &&
                            "Order Has Been Delivered"}
                          {value?.order_status?.id === 5 &&
                            "Order Has Been Cancelled"}
                          {value?.order_status?.id === 6 && "Order Returned"}
                        </h5>
                      </div>
                    ) : (
                      <>
                        <h6 className="order">Order Status</h6>
                        <div className="stepper-div">
                          <ProgressBar
                            percent={
                              item?.order_status?.id === 1
                                ? 0
                                : item?.order_status?.id === 2
                                ? 34
                                : item?.order_status?.id === 3
                                ? 68
                                : item?.order_status?.id === 4
                                ? 100
                                : 0
                            }>
                            <Step>
                              {({ accomplished }) => (
                                <div
                                  className={`indexedStep ${
                                    accomplished ? "accomplished" : ""
                                  }`}>
                                  <div className="range-text-div">
                                    <h6 className="placed">Order Placed</h6>
                                  </div>
                                </div>
                              )}
                            </Step>

                            <Step>
                              {({ accomplished }) => (
                                <div
                                  className={`indexedStep ${
                                    accomplished ? "accomplished" : ""
                                  }`}>
                                  <div className="range-text-div">
                                    <h6 className="placed">Processing</h6>
                                  </div>
                                </div>
                              )}
                            </Step>

                            <Step>
                              {({ accomplished }) => (
                                <div
                                  className={`indexedStep ${
                                    accomplished ? "accomplished" : ""
                                  }`}>
                                  <div className="range-text-div">
                                    <h6 className="placed">Shipped</h6>
                                  </div>
                                </div>
                              )}
                            </Step>

                            <Step>
                              {({ accomplished }) => (
                                <div
                                  className={`indexedStep ${
                                    accomplished ? "accomplished" : ""
                                  }`}>
                                  <div className="range-text-div">
                                    <h6 className="placed">Delivered</h6>
                                  </div>
                                </div>
                              )}
                            </Step>
                          </ProgressBar>
                        </div>
                      </>
                    )}

                    <div className="product-buttons">
                      {item?.order_status?.id === 4 &&
                      item?.return_order?.accept_reject == null ? (
                        <Common_Button
                          onClick={() => handleCancelClick(item?.id)}
                          className="cancel"
                          text="Return"
                        />
                      ) : item?.return_order?.accept_reject === 1 ? (
                        <h4 className="text-success">Return Accepted</h4>
                      ) : item?.return_order?.accept_reject === 0 ? (
                        <h4 className="text-danger">Return Rejected</h4>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <Return_Reason_Modal
          show={showReturn}
          onHide={() => setShowReturn(false)}
          orderId={orderId}
        />
      </section>
    </>
  );
}

export default Main_My_Account;
